import { render, staticRenderFns } from "./Onboarding2.vue?vue&type=template&id=4fd5dddd"
import script from "./Onboarding2.vue?vue&type=script&lang=js"
export * from "./Onboarding2.vue?vue&type=script&lang=js"
import style0 from "./Onboarding2.vue?vue&type=style&index=0&id=4fd5dddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports